define([
    "base/utils/utility"
], function (utils) {
    "use strict";
    function BFController($scope) {
        initCommonPageBanner($scope);
        var hash = location.hash.substring(2);
        if(hash === "register" || hash === "registerFailed") {
            initRegisterPageBanner($scope);
        }
        if(hash === "login") {
            initLoginPageBanner($scope);
        }
        else if(hash === "resetPwd"){
            initresetPwdPageBanner($scope);
        }
        $scope.model.refreshPage = refreshPage;
    };

    function initRegisterPageBanner ($scope) {
        document.title = $scope.i18n("titles.register");

        var redirectUrl = utils.getUrlParams()["service"];
        if(redirectUrl === undefined)
        {
            redirectUrl = "";
        }
        $scope.model.redirectUrl = "/authui" + (redirectUrl.length != 0 ? "?"+redirectUrl : "");
    }

    function initLoginPageBanner ($scope) {
        document.title = $scope.i18n("titles.login");

        $("#enterpriseSwitch").hover(function () {
            $("#languages").hide();
        });
        $("#rootSwitch").hover(function () {
            $("#languages").hide();
        });
    }

    
    function initresetPwdPageBanner($scope){
        $scope.model.isShowLogoutInResetPwdPage = true;
    }

    function refreshPage (language, $scope) {
        var searchStr = window.location.search.substring(1);
        if (searchStr === "")
        {
            window.location.search = "locale=" + language;
        }
        else
        {
            var newSearchStr = "";
            var params = searchStr.split("&");
            var needAddLocale = true;
            // 取出URL中的locale参数，替换为新的语言
            for (var index = 0; index < params.length; index++) {
                var key = params[index].substring(0, params[index].indexOf("="));
                if("locale" === key)
                {
                    var value = params[index].substring(params[index].indexOf("=") + 1);
                    params[index] = key + "=" + language;
                    needAddLocale = false;
                }
                if(index === 0)
                {
                    newSearchStr += params[index];
                }
                else
                {
                    newSearchStr += ("&" + params[index]);
                }
            }
            if(needAddLocale)
            {
                newSearchStr += ("&locale=" + language)
            }
            window.location.search = newSearchStr;
        }
    }

    function initCommonPageBanner ($scope) {
        var languageSwitch = $("#languageSwitch");
        languageSwitch.unbind("hover").hover(function () {
            var languages = $("#languages");
            var loginPageLanguages = $("#loginPageLanguages");
            var children = languages.children();
            if(children.length == 0 && loginPageLanguages.children().length == 0)
            {
            	return;
            }
            for(var index = 0; index < children.length; index++)
            {
                $(children[index]).click(function (event) {
                    refreshPage(event.currentTarget.id, $scope);
                });
            }

            if(!languages.is(":visible"))
            {
                languages.show();
            }

            if(!loginPageLanguages.is(":visible"))
            {
                loginPageLanguages.show();
                if($scope.model.isMobile){
                    var maskDiv = $("<div id='loginPageLanguagesMask' style='position: fixed;top: 0px;left: 0px;width: 100%;height: 100%;background-color: rgba(0,0,0,0.2);z-index: 100;'></div>");
                    $(document.body).append(maskDiv);  
                }
            }
        },function() {
            // 
        });

        $(document).click(function (event) {
            if(event.target !== $("#languageSwitch")[0] && event.target !== $("#languageSwitch > span")[0] && event.target !== $("#languageSwitch > div")[0] && event.target !== $("#languageSwitch > img")[0])
            {
                $("#languages").hide();
                $("#loginPageLanguages").hide();
                $('#loginPageLanguagesMask').remove();
            }
        });
    }
    return BFController;
});


// WEBPACK FOOTER //
// ./public/base/js/framework/controllers/bfController.js